
import firebase from './Firebase.js';
import 'firebase/auth';

let auth = firebase.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

export default auth;
